const HOME = "/";
const TEAM = "/equipe";
const CHALLENGE = "/challenge";
const RESOURCES = "/ressources";
const CONTACT = "/contact";
const BLOG = "/blog";
const TOOLS = "/outils";

const routes = {
	home: HOME,
	team: TEAM,
	tools: TOOLS,
	blog: BLOG,
	casClients: "/cas-clients",
	calendar: "/calendar",
	projectsPot: "/appel-a-projets",
	projectsPotForm: "/appel-a-projets#candidater",
	projectsPotList: "/appel-a-projets#projectsList",
	resources: {
		// footprint: RESOURCES + '/bilancarbone',
		// brief: RESOURCES + '/briefclimat',
		quizEcolo: {
			home: "/quiz-ecolo-boulot",
			quiz: RESOURCES + "/quiz-ecolo" + "/quiz",
			result: RESOURCES + "/quiz-ecolo" + "/resultat",
		},
		whiteBooks: "/livre-blancs",
		whiteBook: "/livre-blanc-rendre-ma-tpe-pme-eco-et-socio-responsable",
		mobilityWhiteBook: "/livre-blanc-inscrire-mobilite-durable-demarche-rse",
		waterWhiteBook: "/livre-blanc-eau",
		pinkOctoberBooklet: "/livret-octobre-rose",
		// coachingContest: '/jeu-concours-coaching',
		newsletter: "/newsletter",
	},
	challenge: {
		home: CHALLENGE,
		internal: CHALLENGE + "/interne",
		school: CHALLENGE + "/etudiant",
		tenant: CHALLENGE + "/locataire",
		companies: CHALLENGE + "/interentreprises",
		//city: CHALLENGE + '/city',
	},
	iskay: "/iskay",
	contact: {
		root: CONTACT + "/",
		challenge: CONTACT + "/challenge",
		structure: CONTACT + "/structure",
		message: CONTACT + "/message",
		rdv: CONTACT + "/rdv",
	},
	footer: {
		disclaimer: "/mentionslegales",
		termsOfUse: "/cgu",
		rgpd: "/rgpd",
		recruitmentPolicy: "/politique-recrutement",
		websitePolicy: "/politique-confidentialite",
	},
	mySpace: {
		dashboard: "https://carnetdebord.energic.io",
		webapp: "https://web.energic.io/",
		footprint: "https://bilancarbone.energic.io/",
	},
	external: {
		engagementClimat23:
			"https://challenge.energic.io/sobriete_sensibilisation_collaborateurs",
	},
};

export default routes;
